import { render, staticRenderFns } from "./CtaDescription.vue?vue&type=template&id=5d3b5f8b&scoped=true&"
import script from "./CtaDescription.vue?vue&type=script&lang=js&"
export * from "./CtaDescription.vue?vue&type=script&lang=js&"
import style0 from "./CtaDescription.vue?vue&type=style&index=0&id=5d3b5f8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3b5f8b",
  null
  
)

export default component.exports